module.exports = __webpack_public_path__ + "static/card-1-fbf68f7bb73c0ab9847e7b3b461b330b.jpg";